import { defineMessages } from 'react-intl';

export const financialDocumentsMessages = defineMessages({
    financialDocuments: {
        id: 'financial-documents',
        defaultMessage: 'Financial documents',
    },
    documents: {
        id: 'documents',
        defaultMessage: 'Documents',
    },
    document: {
        id: 'document',
        defaultMessage: 'Document',
    },
    financialDocument: {
        id: 'financial-document',
        defaultMessage: 'Financial document',
    },
    invoice: {
        id: 'invoice',
        defaultMessage: 'Invoice',
    },
    proforma: {
        id: 'proforma',
        defaultMessage: 'Proforma',
    },
    receipt: {
        id: 'receipt',
        defaultMessage: 'Receipt',
    },
    creditNote: {
        id: 'credit-note',
        defaultMessage: 'Credit note',
    },
    debitNote: {
        id: 'debit-note',
        defaultMessage: 'Debit note',
    },
    searchFinancialDocument: {
        id: 'search-financial-document',
        defaultMessage: 'Search for financial document',
    },
    noFinancialDocument: {
        id: 'no-financial-document',
        defaultMessage: 'No financial document',
    },
    noFinancialDocumentFound: {
        id: 'no-financial-document-found',
        defaultMessage: 'No financial document found',
    },
    draft: {
        id: 'draft',
        defaultMessage: 'Draft',
    },
    issued: {
        id: 'issued',
        defaultMessage: 'Issued',
    },
    voided: {
        id: 'voided',
        defaultMessage: 'Voided',
    },
    amountWithTax: {
        id: 'amount-with-tax',
        defaultMessage: 'Amount with tax',
    },
    financialDocumentDashboard: {
        id: 'financial-document-dashboard',
        defaultMessage: 'Financial document dashboard',
    },
    backToAllFinancialDocuments: {
        id: 'back-to-all-financial-documents',
        defaultMessage: 'Back to all financial documents',
    },
    deleteFinancialDocument: {
        id: 'delete-financial-document',
        defaultMessage: 'Delete financial document',
    },
    deleteFinancialDocumentSuccess: {
        id: 'delete-financial-document-success',
        defaultMessage: 'Financial document deleted',
    },
    deleteFinancialDocumentSuccessDescription: {
        id: 'delete-financial-document-success-description',
        defaultMessage: 'The financial document has been successfully deleted.',
    },
    confirmDeleteFinancialDocument: {
        id: 'confirm-delete-financial-document',
        defaultMessage: 'Are you sure you want to delete this financial document? This action cannot be undone.',
    },
    deleteFinancialDocumentSubtitle: {
        id: 'delete-financial-document-subtitle',
        defaultMessage: 'Permanently delete financial document',
    },
    publicDescription: {
        id: 'public-description',
        defaultMessage: 'Public description',
    },
    internalDescription: {
        id: 'internal-description',
        defaultMessage: 'Internal description',
    },
    paymentDueDate: {
        id: 'payment-due-date',
        defaultMessage: 'Payment due date',
    },
    taxEventDate: {
        id: 'tax-event-date',
        defaultMessage: 'Tax event date',
    },
    number: {
        id: 'number',
        defaultMessage: 'Number',
    },
    createFinancialDocumentSuccess: {
        id: 'create-financial-document-success',
        defaultMessage: 'Financial document created',
    },
    createFinancialDocumentSuccessDescription: {
        id: 'create-financial-document-success-description',
        defaultMessage: 'The financial document has been successfully created.',
    },
    addFinancialDocumentSubtitle: {
        id: 'add-financial-document-subtitle',
        defaultMessage: 'Create a new financial document',
    },
    refNumber: {
        id: 'ref-number',
        defaultMessage: 'Ref number',
    },
    editFinancialDocumentSubtitle: {
        id: 'edit-financial-document-subtitle',
        defaultMessage: 'Edit financial document',
    },
    updateFinancialDocumentSuccess: {
        id: 'update-financial-document-success',
        defaultMessage: 'Financial document updated',
    },
    updateFinancialDocumentSuccessDescription: {
        id: 'update-financial-document-success-description',
        defaultMessage: 'The financial document has been successfully updated.',
    },
    issueFinancialDocument: {
        id: 'issue-financial-document',
        defaultMessage: 'Issue document',
    },
    issue: {
        id: 'issue',
        defaultMessage: 'Issue',
    },
    issueFinancialDocumentSuccessDescription: {
        id: 'issue-financial-document-success-description',
        defaultMessage: 'The financial document has been successfully issued.',
    },
    confirmIssueFinancialDocument: {
        id: 'confirm-issue-financial-document',
        defaultMessage: 'Are you sure you want to issue this financial document? This action cannot be undone.',
    },
    issueFinancialDocumentSubtitle: {
        id: 'issue-financial-document-subtitle',
        defaultMessage: 'Issue financial document',
    },
    issueFinancialDocumentSuccess: {
        id: 'issue-financial-document-success',
        defaultMessage: 'Issued financial document',
    },
    missingAccountingRangeIssueError: {
        id: 'custom-error:missing_accounting_range',
        defaultMessage: 'Financial document cannot be issued without accounting range!',
    },
    missingFinancialDocumentNumberIssueError: {
        id: 'custom-error:missing_financial_document_number',
        defaultMessage: 'Financial document cannot be issued without number!',
    },
    exceedingAccountingRangeIssueError: {
        id: 'custom-error:exceeded_accounting_range',
        defaultMessage: 'Financial document cannot be issued due to exceeded accounting range!',
    },
    missingDocumentRowsIssueError: {
        id: 'custom-error:issue_empty_financial_document',
        defaultMessage: 'Cannot issue empty financial document, at least one row is required to proceed!',
    },
    numberOutOfAccountingRangeError: {
        id: 'custom-error:number_out_of_accounting_range_boundary_error',
        defaultMessage:
            'Financial document cannot be created because the number does not fit into the accounting range boundary!',
    },
    uniqueNumberError: {
        id: 'custom-error:number',
        defaultMessage: 'Financial document with this number already exists.',
    },
    financialDocBillingEntity: {
        id: 'financial-doc-billing-entity',
        defaultMessage: 'Billing entity',
    },
    financialDocCustomer: {
        id: 'financial-doc-customer',
        defaultMessage: 'Customer',
    },
    searchFinancialDocCustomer: {
        id: 'search-financial-doc-customer',
        defaultMessage: 'Search customer',
    },
    noFinancialDocCustomer: {
        id: 'no-financial-doc-customer',
        defaultMessage: 'No customer',
    },
    noFinancialDocCustomerFound: {
        id: 'no-financial-doc-customer-found',
        defaultMessage: 'No customer found',
    },
    paidAmount: {
        id: 'paid-amount',
        defaultMessage: 'Paid amount',
    },
    regenerateFinancialDocumentSubtitle: {
        id: 'regenerate-financial-document-subtitle',
        defaultMessage: 'Regenerate financial document',
    },
    regenerateFinancialDocumentSuccess: {
        id: 'regenerate-financial-document-success',
        defaultMessage: 'Regenerated financial document',
    },
    regenerate: {
        id: 'regenerate',
        defaultMessage: 'Regenerate',
    },
    generateDocument: {
        id: 'generate-document',
        defaultMessage: 'Generate document',
    },
    regenerateFinancialDocument: {
        id: 'regenerate-financial-document',
        defaultMessage: 'Regenerate financial document',
    },
    regenerateFinancialDocumentSuccessDescription: {
        id: 'regenerate-financial-document-success-description',
        defaultMessage: 'The financial document has been successfully regenerated.',
    },
    confirmRegenerateFinancialDocument: {
        id: 'confirm-regenerate-financial-document',
        defaultMessage: 'Are you sure you want to regenerate this financial document? This action cannot be undone.',
    },
    missingPdfTemplateError: {
        id: 'custom-error:missing_pdf_template',
        defaultMessage: 'Pdf cannot be generated because no template has been selected!',
    },
    missingTemplateLogoError: {
        id: 'custom-error:missing_logo_for_pdf_template',
        defaultMessage: 'Pdf cannot be generated because the chosen template requires logo but none was provided!',
    },
    exportDocumentInDraftError: {
        id: 'custom-error:export_financial_document_in_draft_state',
        defaultMessage:
            'Cannot export financial document that is in draft state, the document must have been issued before the generation of the pdf!',
    },
    preview: {
        id: 'preview',
        defaultMessage: 'Preview',
    },
    remainingAmount: {
        id: 'remaining-amount',
        defaultMessage: 'Remaining amount',
    },
    issueDate: {
        id: 'issue-date',
        defaultMessage: 'Issue date',
    },
    createdAt: {
        id: 'created-at',
        defaultMessage: 'Created at',
    },
    createdBy: {
        id: 'created-by',
        defaultMessage: 'Created by',
    },
    taxAmount: {
        id: 'tax-amount',
        defaultMessage: 'Tax amount',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    priceWithTax: {
        id: 'price-with-tax',
        defaultMessage: 'Price with tax',
    },
    issuedBy: {
        id: 'issued-by',
        defaultMessage: 'Issued by',
    },
    issueMissingPaymentDueDateError: {
        id: 'custom-error:issue_financial_document_with_incorrect_payment_due_date_error',
        defaultMessage:
            'Financial document cannot be issued because the payment due date is either missing or has already passed!',
    },
    issueMissingTaxEventDateError: {
        id: 'custom-error:issue_financial_document_without_tax_event_date_error',
        defaultMessage: 'Financial document cannot be issued without tax event date!',
    },
    issueDueDateError: {
        id: 'custom-error:invalid_issue_due_date_error',
        defaultMessage: 'The issue due date must not precede the date of the last issued financial document!',
    },
    relatedRecordsError: {
        id: 'custom-error:item_with_related_records_error',
        defaultMessage: 'This item cannot be deleted because it has related records!',
    },
});
